module.exports = __webpack_public_path__ + "images/e0b8ca0.png";